import React, { useState } from "react";
import Stats from "../components/chart/GeneralCom.jsx";
import { useTheme } from "../components/context/index.jsx";
import Pie from "../components/chart/Pie.jsx";
import Bar from "../components/chart/Bar.jsx";
import StatsTwo from "../components/chart/StatsTwo.jsx";
import Recommeditions from "../components/chart/Recommeditions.jsx";

const mockdata = [
  {
    "id": "make",
    "label": "make",
    "value": 424,
    "color": "hsl(18, 70%, 50%)"
  },
  {
    "id": "c",
    "label": "c",
    "value": 593,
    "color": "hsl(103, 70%, 50%)"
  },
  {
    "id": "javascript",
    "label": "javascript",
    "value": 499,
    "color": "hsl(195, 70%, 50%)"
  },
  {
    "id": "lisp",
    "label": "lisp",
    "value": 371,
    "color": "hsl(3, 70%, 50%)"
  },
  {
    "id": "erlang",
    "label": "erlang",
    "value": 160,
    "color": "hsl(63, 70%, 50%)"
  }
]

export default function Dashboard() {
  // const { profile } = useTheme();
  // let fin = ['Tasischi', 'Finance'];

  const [sectorsData, setSectorsData] = useState(null);

  return (
    <div>
      <Stats />
      <StatsTwo/>
      <p className="m-1 mt-1 text-4xl">Tavsiyalar:</p>
      <Recommeditions/> 
      <div className="grid gap-4 grid-cols-2 container mx-auto">
        {/* {fin.includes(profile?.type_dict?.title) ?
          < Chart />
          : ''
        } */}
        {/* <div className="h-96">
          <Pie mockdata={mockdata} />
        </div>
        <div className="h-96">

          <Bar data={sectorsData} />
        </div> */}
      </div>
    </div>
  );
}
